module.exports = __webpack_public_path__ + "img/img-ef825d19.da183c65.png";